import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Card,
    CardContent,
    CardHeader,
    Button,
    Typography,
    TextField
} from "@material-ui/core";
import { getReport,getJobPackReports } from "./actions";
import { selectReport } from "./selectors";
import { gridStyle as gs, cellStyle as cs } from "../gridHelper";
import ReactToPrint from "react-to-print";

import styled from "styled-components";

const TextDiv = styled.div`
    width: 45%;
    border-radius: 10px;
    padding: 20px;
    background-color: lightgray;
    margin-bottom: 10px;
`;
const InfoDiv = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
`;
class Incident extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getJobPackReports(
                props.match.params.uprn,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                    path[7].replace(/-/g, "_")
            );
        }
        this.state = {
            report: false,
            edit: path[1] === "report-view" ? false : path[1] === "report-view-standalone" ? false : true,
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.report !== this.props.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderTextDetail = key => {
        const { report } = this.state;
        if (this.state.edit) {
            return (
                <div>
                    <TextField
                        key={key}
                        value={report[key]}
                        onChange={event => {
                            let report = {
                                ...this.state.report,
                                [key]: event.target.value
                            };
                            this.setState({ report });
                        }}
                    />
                </div>
            );
        } else {
            return this.state.report[key] ? this.state.report[key] : "N/A";
        }
    };
    render() {
        const { report } = this.state;
        //TODO: create new renderDropdown function for selectable options. (IF NEEDED, currently report is uneditable)
        const rt = this.renderTextDetail;
        let color = this.props.color;
        return (
            <Card>
                <CardHeader title="Incident/Near Miss Form" />
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px"
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    {report && (
                        <div ref={el => (this.componentRef = el)}>
                            {this.props.header && (
                                <this.props.header
                                    date={this.props.match.params.report_id}
                                    reportType={this.props.reportType}
                                />
                            )}

                            <Typography className={"reportURN"} variant="title">
                                Incident Form No:
                                {report.urn === undefined ? "N/A" : report.urn}
                            </Typography>

                            <InfoDiv>
                                <div style={{ width: "45%" }}>
                                    <div style={gs(4, 4, null, color)}>
                                        <div
                                            style={cs(1, 1, 1, 4, false, true)}
                                        >
                                            Report Information
                                        </div>
                                        <div style={cs(2, 1, 2, 4)}>
                                            User Name:
                                        </div>
                                        <div style={cs(2, 3, 2, 4, true)}>
                                            {report.user_name
                                                ? report.user_name
                                                : "NA"}
                                        </div>
                                        <div style={cs(3, 1, 3, 4)}>
                                            User Email:
                                        </div>
                                        <div style={cs(3, 3, 3, 4, true)}>
                                            {report.user_email
                                                ? report.user_email
                                                : "NA"}
                                        </div>
                                        <div style={cs(4, 1, 4, 4)}>
                                            Timestamp:
                                        </div>
                                        <div style={cs(4, 3, 4, 4, true)}>
                                            {report.timestamp
                                                ? report.timestamp
                                                : "NA"}
                                        </div>
                                    </div>
                                </div>
                                <TextDiv>
                                    <Typography variant="title">
                                        This form must be completed by the
                                        person responsible for the injured party
                                        (Supervisor/Manager) for each incident
                                        in which injury occurs or an illness is
                                        aquired whilst at work. It does not
                                        replace and may not be used in addition
                                        to Sick Leave or Worker's Compensation
                                        Claim Forms, where applicable
                                    </Typography>
                                </TextDiv>
                            </InfoDiv>
                            <div style={gs(6, 9, null, color)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    Details of Person Involved in
                                    Injury/Illness/Accident
                                </div>
                                <div style={cs(2, 1, 2, 5)}>Employee Name:</div>
                                <div style={cs(2, 3, 2, 5, true)}>
                                    {rt("employee_name")}
                                </div>
                                <div style={cs(2, 5, 2, 9)}>
                                    Employee Contact No.:
                                </div>
                                <div style={cs(2, 7, 2, 9, true)}>
                                    {rt("employee_contact_no")}
                                </div>

                                <div style={cs(3, 1, 3, 5)}>
                                    Employee Home Address:
                                </div>
                                <div style={cs(3, 3, 3, 5, true)}>
                                    {rt("employee_home_address")}
                                </div>

                                <div style={cs(3, 5, 3, 9)}>
                                    Employment/Relationship status to
                                    Organisation:
                                </div>
                                <div style={cs(3, 7, 3, 9, true)}>
                                    {rt("employee_relationship_with_department")}
                                </div>

                                <div style={cs(4, 1, 4, 5)}>
                                    Employee Position:
                                </div>
                                <div style={cs(4, 3, 4, 5, true)}>
                                    {rt("employee_position")}
                                </div>
                                <div style={cs(4, 5, 4, 9)}>
                                    Does employee work for any other
                                    organisation:
                                </div>
                                <div style={cs(4, 7, 4, 9, true)}>
                                    {rt("employee_work_for_other_org")}
                                </div>

                                <div style={cs(5, 1, 5, 5)}>
                                    Vistors/Clients (Area Visited):
                                </div>
                                <div style={cs(5, 3, 5, 5, true)}>
                                    {rt("employee_areas_visited")}
                                </div>
                                <div style={cs(5, 5, 5, 9)} />
                            </div>
                            <div style={gs(3, 9, null, color)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    Work Details
                                </div>
                                <div style={cs(2, 1, 2, 5)}>Location:</div>
                                <div style={cs(2, 3, 2, 5, true)}>
                                    {rt("work_location_address")}
                                </div>
                                <div style={cs(2, 5, 2, 9)}>
                                    Employee Department:
                                </div>
                                <div style={cs(2, 7, 2, 9, true)}>
                                    {rt("employee_department")}
                                </div>
                            </div>
                            <div style={gs(8, 9, null, color)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    Injury/Incident/Illness Details
                                </div>
                                <div style={cs(2, 1, 2, 5)}>
                                    Date Of Injury/Illness/Incident:
                                </div>
                                <div style={cs(2, 3, 2, 5, true)}>
                                    {rt("date_of_incident")}
                                </div>
                                <div style={cs(2, 5, 2, 9)}>
                                    Time Of Injury/Incident/Illness:
                                </div>
                                <div style={cs(2, 7, 2, 9, true)}>
                                    {rt("time_of_incident")}
                                </div>
                                <div style={cs(3, 1, 4, 9)}>
                                    Description Of Occurence:
                                </div>
                                <div style={cs(3, 3, 4, 9, true)}>
                                    {rt("desc_of_incident")}
                                </div>
                                <div style={cs(5, 1, 5, 5)}>
                                    Type Of Incident:
                                </div>
                                <div style={cs(5, 3, 5, 5, true)}>
                                    {rt("type_of_incident")}{" "}
                                </div>
                                <div style={cs(5, 5, 5, 9)}>
                                    Type Of Injury:
                                </div>
                                <div style={cs(5, 7, 5, 9, true)}>
                                    {rt("type_of_injury")}
                                </div>

                                <div style={cs(6, 1, 6, 5)}>
                                    Apparent Type Of Illness:
                                </div>
                                <div style={cs(6, 3, 6, 5, true)}>
                                    {rt("type_of_illness")}{" "}
                                </div>
                                <div style={cs(6, 5, 6, 9)}>
                                    Bodily Location:
                                </div>
                                <div style={cs(6, 7, 6, 9, true)}>
                                    {rt("bodily_location")}
                                </div>

                                <div style={cs(7, 1, 7, 5)}>
                                    Agency (What Caused Incident):
                                </div>
                                <div style={cs(7, 3, 7, 5, true)}>
                                    {rt("agency_cause_of_incident")}{" "}
                                </div>
                                <div style={cs(7, 5, 7, 9)}>
                                    When Did The Incident Occur:
                                </div>
                                <div style={cs(7, 7, 7, 9, true)}>
                                    {rt("when_incident_occurred")}
                                </div>

                                <div style={cs(8, 1, 8, 5)}>
                                    Where Did Incident Occur:
                                </div>
                                <div style={cs(8, 3, 8, 5, true)}>
                                    {rt("where_incident_occurred")}
                                </div>
                                <div style={cs(8, 5, 8, 9)} />
                            </div>
                            <div style={gs(2, 9, null, color)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    After The Incident
                                </div>
                                <div style={cs(2, 1, 2, 5)}>
                                    Action Person Took:
                                </div>
                                <div style={cs(2, 3, 2, 5, true)}>
                                    {rt("after_incident_did")}
                                </div>
                                <div style={cs(2, 5, 2, 9)}>
                                    Was First Aid Recieved:
                                </div>
                                <div style={cs(2, 7, 2, 9, true)}>
                                    {rt("after_incident_first_aid")}
                                </div>
                            </div>
                            <div style={gs(2, 9, null, color)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    Time Lost
                                </div>
                                <div style={cs(2, 1, 2, 5)}>
                                    Time Lost: From
                                </div>
                                <div style={cs(2, 3, 2, 5, true)}>
                                    {rt("time_lost_from")}
                                </div>
                                <div style={cs(2, 5, 2, 9)}>Time Lost: To</div>
                                <div style={cs(2, 7, 2, 9, true)}>
                                    {rt("time_lost_to")}
                                </div>
                            </div>
                            <div style={gs(3, 9, null, color)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    Details Of Witness To Incident (Witness To
                                    Fill Out Insurer Witness Form)
                                </div>
                                <div style={cs(2, 1, 2, 5)}>Witness Name:</div>
                                <div style={cs(2, 3, 2, 5, true)}>
                                    {rt("witness_name")}
                                </div>
                                <div style={cs(2, 5, 2, 9)}>
                                    Witness Contact No.:
                                </div>
                                <div style={cs(2, 7, 2, 9, true)}>
                                    {rt("witness_contact_no")}
                                </div>
                                <div style={cs(3, 1, 3, 5)}>
                                    Witness Address:
                                </div>
                                <div style={cs(3, 3, 3, 5, true)}>
                                    {rt("witness_address")}{" "}
                                </div>

                                <div style={cs(3, 5, 3, 9)}>
                                    Personnel Type:
                                </div>
                                <div style={cs(3, 7, 3, 9, true)}>
                                    {rt("personnel_type")}
                                </div>

                                <div style={cs(4, 1, 4, 5)}>
                                    Risk Assessment Reviewed:
                                </div>
                                <div style={cs(4, 3, 4, 5, true)}>
                                    {rt("risk_asses_reviewed")}
                                </div>

                                <div style={cs(4, 5, 4, 9)}>
                                    Risk Assessment Amended:
                                </div>
                                <div style={cs(4, 7, 4, 9, true)}>
                                    {rt("risk_asses_amended")}
                                </div>
                            </div>
                        </div>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    store => {
        return {
            report: selectReport(store)
        };
    },
    { getReport,getJobPackReports }
)(Incident);
